import PropTypes from 'prop-types'
import React from 'react'

export default function IconRegions({ className }) {
  return (
    <span
      className={`${className} main-icon-container main-icon-container-regions`}
    >
      <svg
        className="main-icon main-icon-regions"
        viewBox="0 0 80 80"
        enableBackground="new 0 0 80 80"
      >
        <path d="M61.377,31.057c0-12.435-10.081-22.514-22.516-22.514s-22.515,10.08-22.515,22.514
  c0,5.821,2.228,11.106,5.852,15.104l7.889,11.976l8.774,13.321l8.774-13.321l7.889-11.976
  C59.149,42.163,61.377,36.878,61.377,31.057z"
        />
        <circle cx="38.861" cy="30.058" r="13.509" />
      </svg>
      <span>
        Landkreis
      </span>
    </span>
  )
}

IconRegions.propTypes = {
  className: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/IconRegions.js